// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kl1e","question":"styles_question__3NGmD","description":"styles_description__1loZX"};